module.exports = __webpack_public_path__ + "img/LDSJ_STILL29.41935327.jpg";